import React, { useRef } from "react";
import leafFlutteringInWind from "assets/images/leaf-fluttering-in-wind.png";
import sneezingFace from "assets/images/sneezing-face.png";
import baby from "assets/images/baby.png";
import dogFace from "assets/images/dog-face.png";
import construction from "assets/images/construction.png";
import woman from "assets/images/woman.png";
import explodingHead from "assets/images/exploding-head.png";
import loadable from "@loadable/component";

const LazyImg = loadable(() => import("../common/LazyImg"));

const PerformanceStats = () => {
  const tooltipRefs = useRef([]).current;
  return (
    <section className="performance-stats">
      <div className="container">
        <h2 className="performance-stats__title">Proven filter performance.</h2>
        <div className="performance-stats__description">
          <p>
            At Mila we believe in total transparency and are happy to share the
            results of our filter tests.
          </p>
          <p>
            In creating our filters, we ran each one in test chambers filled
            with all sorts of nasties to evaluate performance and optimize the
            design. Here’s where each filter netted out:
          </p>
        </div>
        <div className="performance-stats__inner">
          <table className="performance-stats__table">
            <tbody>
              <tr className="tr-exclude">
                <td className="row-header">&nbsp;</td>
                <td className="row-header row-header--radius">&nbsp;</td>
              </tr>
              <tr className="tr-exclude">
                <td className="row-header">&nbsp;</td>
                <td className="row-header">
                  <span className="row-header__column-wrap">
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={leafFlutteringInWind}
                        alt="leaf-fluttering-in-wind"
                      />
                      <strong>The Basic Breather</strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={sneezingFace}
                        alt="sneezing-face"
                      />
                      <strong>The Big Sneeze</strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={baby}
                        alt="baby"
                      />
                      <strong>The Rookie Parent</strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={dogFace}
                        alt="dog-face"
                      />
                      <strong>The Critter Cuddler</strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={construction}
                        alt="construction"
                      />
                      <strong>The Home Wrecker</strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={woman}
                        alt="woman"
                      />
                      <strong>
                        The
                        <br />
                        Mama-to-Be
                      </strong>
                    </span>
                    <span className="row-header__column">
                      <LazyImg
                        className="row-label__image"
                        src={explodingHead}
                        alt="exploding-head"
                      />
                      <strong>The Overreactor</strong>
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">
                    Cadr
                    <small>(m<sup>3</sup>/hr)</small>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Cadr
                    <small>
                      (m<sup>3</sup>/hr)
                    </small>
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Basic Breather"
                    >
                      460
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Big Sneeze"
                    >
                      412
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Rookie Parent"
                    >
                      386
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      350
                    </span>
                    <span className="row-value" data-filter="The Home Wrecker">
                      308
                    </span>
                    <span className="row-value" data-filter="The Mama-to-Be">
                      262
                    </span>
                    <span className="row-value" data-filter="The Overreactor">
                      265
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Tvoc Removal Rate</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">60mins, 9 VOC types</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Tvoc Removal Rate
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Tvoc Removal Rate info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        Tvoc Removal Rate info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[0] = el)}
                  >
                    60mins, 9 VOC types
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box row-value--top-radius"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box row-value--top-radius"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      74.85%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      75.56%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      92.81%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.48%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      97.89%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Formaldehyde</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">furniture</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Formaldehyde
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Formaldehyde info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        Formaldehyde info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[1] = el)}
                  >
                    furniture
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      45.40%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      34.00%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      95.60%
                    </span>
                    <span className="row-value" data-filter="The Mama-to-Be">
                      48.8%*
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      96.60%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Ammonia</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">pet odor</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Ammonia
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Ammonia info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">Ammonia info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[2] = el)}
                  >
                    pet odor
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      21.52%*
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Critter Cuddler"
                    >
                      75.60%
                    </span>
                    <span className="row-value" data-filter="The Home Wrecker">
                      31.20%*
                    </span>
                    <span className="row-value" data-filter="The Mama-to-Be">
                      4.80%
                    </span>
                    <span className="row-value" data-filter="The Overreactor">
                      17.20%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Benzene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      Cleaning supplies, tobacco smoke
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Benzene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Benzene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">Benzene info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[3] = el)}
                  >
                    Cleaning supplies, tobacco smoke
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      78.57%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      75.00%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      91.02%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.98%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      96.94%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Toluene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">paint, detergents</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Toluene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Toluene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">Toluene info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[4] = el)}
                  >
                    paint, detergents
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      76.39%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      77.33%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      94.86%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      94.80%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.99%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Butyl Acetate</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">households odors</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Butyl Acetate
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Butyl Acetate info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        Butyl Acetate info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[5] = el)}
                  >
                    households odors
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      75.58%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      76.40%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      93.79%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      93.33%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.49%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">N-undecane</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">cooking and food odors</span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    N-undecane
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="N-undecane info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        N-undecane info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[6] = el)}
                  >
                    cooking and food odors
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box row-value--gray-text"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box row-value--gray-text"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      75.34%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      76.92%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      93.33%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.47%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.06%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Ethylbenzene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      paint, varnishes, cleaning supplies
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Ethylbenzene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Ethylbenzene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        Ethylbenzene info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[7] = el)}
                  >
                    paint, varnishes, cleaning supplies
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      74.68%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      75.61%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      92.96%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.20%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.00%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">P-xyleneou</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      paint, adhesives, permanent markers
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    P-xyleneou
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="P-xyleneou info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">
                        P-xyleneou info
                      </span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[8] = el)}
                  >
                    paint, adhesives, permanent markers
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      73.97%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      76.00%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      93.47%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.76%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.24%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">M-xylene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      paint, adhesives, permanent markers
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    M-xylene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="M-xylene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">M-xylene info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[9] = el)}
                  >
                    paint, adhesives, permanent markers
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      74.68%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      75.31%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      93.25%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      92.56%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      98.13%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">O-xylene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      paint, adhesives, permanent markers
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    O-xylene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label=" O-xylene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text"> O-xylene info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[10] = el)}
                  >
                    paint, adhesives, permanent markers
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      74.30%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      73.61%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      92.60%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      91.95%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      97.89%
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="row-label">Styrene</span>
                  <span className="tooltip">
                    <svg className="icon icon-info">
                      <use xlinkHref="#icon-info" />
                    </svg>
                    <span className="tooltiptext">
                      printers, rubber flooring, insulation
                    </span>
                  </span>
                </td>
                <td>
                  <span className="hidden-label">
                    Styrene
                    <button
                      type="button"
                      className="trigger-info"
                      aria-label="Styrene info"
                    >
                      <svg className="icon icon-info">
                        <use xlinkHref="#icon-info" />
                      </svg>
                      <span className="screen-reader-text">Styrene info</span>
                    </button>
                  </span>
                  <span
                    className="info-text"
                    ref={(el) => (tooltipRefs[11] = el)}
                  >
                    printers, rubber flooring, insulation
                  </span>
                  <span className="row-wrap">
                    <span
                      className="row-value row-value--gray-box row-value--bottom-radius"
                      data-filter="The Basic Breather"
                    >
                      N/A
                    </span>
                    <span
                      className="row-value row-value--gray-box row-value--bottom-radius"
                      data-filter="The Big Sneeze"
                    >
                      N/A
                    </span>
                    <span className="row-value" data-filter="The Rookie Parent">
                      70.00%
                    </span>
                    <span
                      className="row-value"
                      data-filter="The Critter Cuddler"
                    >
                      71.43%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Home Wrecker"
                    >
                      88.52%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Mama-to-Be"
                    >
                      89.03%
                    </span>
                    <span
                      className="row-value row-value--text-bold"
                      data-filter="The Overreactor"
                    >
                      96.10%
                    </span>
                  </span>
                </td>
              </tr>

              <tr className="tr-exclude">
                <td>
                  <span className="row-label">&nbsp;</span>
                </td>
                <td className="row-value--radius">
                  <span className="row-value"> </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default PerformanceStats;
